import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource-variable/geist';
import '@fontsource-variable/geist-mono';
import '@fontsource/instrument-serif/400-italic.css';
import { initTheme } from '@dezza/ui';
import './styles.css';
import { App } from './app/App';
import { initTokenStore } from './lib/platform';

// Tema salvo no aparelho (o /theme-boot.js do index.html já aplicou antes da pintura; aqui garante).
initTheme();

// No app mobile, o token vem do armazenamento seguro (assíncrono) antes da primeira chamada à API.
void initTokenStore().finally(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
